module.exports = __webpack_public_path__ + "img/body-2-lg.8e91fbd5.png";